<!-- Home Costing Information -->
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
    <ion-title [innerHTML]="(displayAddress$ | async) || 'Budget'"></ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-card>
    <ion-accordion-group>
      <ion-accordion value="property-details">
        <ion-item slot="header" color="primary">
          <ion-label>
            <h5>Loan Details</h5>
          </ion-label>
        </ion-item>
        <div class="ion-padding" slot="content">
          @if (homeFieldList.length > 0) {
            <form
              class="CostDetails__Form dynamic-form"
              [formGroup]="summaryForm"
            >
              @for (field of homeFieldList; track field.name) {
                <ng-container
                  dynamicField
                  [field]="field"
                  [group]="summaryForm"
                >
                </ng-container>
              }
            </form>
          }
        </div>
      </ion-accordion>
    </ion-accordion-group>
  </ion-card>

  <ion-card>
    <ion-card-header>
      <ion-card-title>Budget</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="row">
        <div class="col-6 d-flex justify-content-between flex-column">
          <ion-label>Total Budgeted Costs</ion-label>
          <h4
            class="CostDetails__Values"
            [innerHTML]="
              roi.calculationValues['allBudgetCosts']
                | currency: 'USD' : 'symbol' : '1.0-0'
            "
          ></h4>
        </div>
        <div class="col-6 d-flex justify-content-between flex-column">
          <ion-label>Net Profit</ion-label>
          @let profit = roi.calculationValues['profit'];
          <h4
            class="CostDetails__Values"
            [ngClass]="profit > 0 ? 'green' : 'red'"
            [innerHTML]="profit | currency: 'USD' : 'symbol' : '1.0-0'"
          ></h4>
        </div>
      </div>
      <div class="row">
        <app-budget-panel class="CostDetails__BudgetPanel"></app-budget-panel>
      </div>
    </ion-card-content>
  </ion-card>
</ion-content>
